import { Plugin } from 'ckeditor5';
import { v4 as uuid } from 'uuid';
import { ConditionState } from './State';
import { InsertConditionCommand } from './insertCommand';
import './style.css';
export class ConditionsSchema extends Plugin {
    static get pluginName() {
        return 'ConditionsSchema';
    }
    init() {
        this.state = this.editor.plugins.get(ConditionState);
        this.defineSchema();
        this.defineConverters();
        this.defineCommands();
    }
    defineCommands() {
        const { editor } = this;
        editor.commands.add(InsertConditionCommand.pluginName, new InsertConditionCommand(editor));
    }
    defineSchema() {
        const { schema } = this.editor.model;
        schema.extend('$text', {
            allowAttributes: ['conditionMarker'],
        });
    }
    defineConverters() {
        const { editor } = this;
        // Map to track instance IDs for matching start/end pairs
        const conditionInstanceMap = new Map();
        // DATA UPCAST - Handle condition-start and condition-end elements
        editor.conversion.for('upcast').elementToMarker({
            view: 'condition-start',
            model: (viewElement) => {
                const id = viewElement.getAttribute('name');
                this.state.addCondition(id);
                // Create unique instance ID for this condition pair
                const instanceId = uuid();
                // Store it so condition-end can use the same one
                conditionInstanceMap.set(id, instanceId);
                return `condition-inline:${id}:${instanceId}`;
            },
            converterPriority: 'high',
        });
        editor.conversion.for('upcast').elementToMarker({
            view: 'condition-end',
            model: (viewElement) => {
                const id = viewElement.getAttribute('name');
                // Retrieve the instance ID from the matching condition-start
                const instanceId = conditionInstanceMap.get(id);
                // Clear it for the next pair
                conditionInstanceMap.delete(id);
                return `condition-inline:${id}:${instanceId}`;
            },
            converterPriority: 'high',
        });
        editor.conversion.for('dataDowncast').markerToElement({
            model: 'condition-inline',
            view: (markerData, { writer }) => {
                const { markerName } = markerData;
                // Extract condition ID, ignoring instance ID
                const parts = markerName.split(':');
                const [, type, id] = parts;
                const name = `${type}:${id}`;
                if (markerData.isOpening) {
                    return writer.createEmptyElement('condition-start', { name });
                }
                return writer.createEmptyElement('condition-end', { name });
            },
        });
        editor.conversion.for('editingDowncast').markerToHighlight({
            model: 'condition-inline',
            view: (data) => {
                const parts = data.markerName.split(':');
                const [, type, id] = parts;
                return {
                    name: 'span',
                    classes: ['condition'],
                    attributes: {
                        'data-condition': 'inline',
                        'data-condition-id': `${type}:${id}`,
                    },
                };
            },
        });
    }
}
